<script lang="ts">
    export let name: string;
    export let title: string;
    export let id: string
    export let rows = 4;
    export let value: string | null | number;
    export let errorMessage: null | string = null;
    export let loading = false;
</script>

<div>
    <label for={id} class="block text-sm font-medium leading-6 text-gray-900" class:text-red-600={errorMessage}>{title}</label>
    <div class="relative mt-2">
        <textarea {rows} {name} {id}
                  class="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200"
                  class:text-red-900={errorMessage}
                  class:ring-red-300={errorMessage}
                  class:placeholder:text-red-300={errorMessage}
                  class:focus:ring-red-500={errorMessage}
                  on:input={() => errorMessage = null}
                  disabled={loading} bind:value></textarea>
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-start pt-1.5 pr-3">
            {#if errorMessage}
                <svg class="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                </svg>
            {/if}
        </div>
    </div>
    {#if errorMessage}
        <p class="mt-2 text-sm text-red-600">{errorMessage}</p>
    {/if}
</div>
